import React from 'react';
import { api, formatINR } from '../../../lib/store';
import { formatSizeInput } from '../../../lib/utils';
import { Input } from '../../ui/input';
import { Button } from '../../ui/button';
import { Label } from '../../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Badge } from '../../ui/badge';
import { Separator } from '../../ui/separator';
import { toast } from 'sonner';
import { Plus, Pencil, Trash2, Search, ChevronLeft, ChevronRight, Image as ImageIcon, X, Wrench, Upload, Package, Zap, Download } from 'lucide-react';
import { logger } from '../../../lib/logger';
import {
  CATEGORIES,
  RATE_TYPES,
  THICKNESS_BULK_CATEGORIES,
  WEIGHT_BULK_CATEGORIES,
  PLYWOOD_THICKNESSES,
  BLOCKBOARD_THICKNESSES,
  MDF_THICKNESSES,
  DOORS_THICKNESSES,
  WPCPVC_THICKNESSES,
  ACP_THICKNESSES,
  ADHESIVE_WEIGHTS,
  PLYWOOD_SIZES,
  DOOR_SIZES,
  DOOR_SIZES_WITH_SQFT,
  emptyProduct,
} from '../constants';

// Extracted from ProductManagement.js (R2). Receives parent state/handlers as props.
export function ImageUploadDialog(props) {
  const {
    BACKEND_URL,
    handleImageUpload,
    imageInputRef,
    imageProduct,
    setShowImageDialog,
    showImageDialog,
    uploading,
  } = props;
  return (
    <>
      {/* Image Upload Dialog */}
      <Dialog open={showImageDialog} onOpenChange={setShowImageDialog}>
        <DialogContent className="max-w-sm" data-testid="image-upload-dialog">
          <DialogHeader>
            <DialogTitle>Upload Product Image</DialogTitle>
          </DialogHeader>
          {imageProduct && (
            <div className="space-y-4">
              <div className="text-sm">
                <span className="font-semibold">{imageProduct.brand_name}</span>
                <span className="text-heda-mute ml-2">{imageProduct.product_name || imageProduct.subcategory}</span>
              </div>
              
              {imageProduct.image_url && (
                <div className="relative">
                  <img 
                    src={imageProduct.image_url.startsWith('/api') ? `${BACKEND_URL}${imageProduct.image_url}` : imageProduct.image_url} 
                    alt="Current" 
                    className="w-full h-40 object-cover rounded-lg border border-heda-line"
                  />
                  <span className="absolute top-2 left-2 bg-black/60 text-white text-xs px-2 py-1 rounded-lg">Current Image</span>
                </div>
              )}

              <div className="border-2 border-dashed border-heda-line rounded-xl p-6 text-center hover:border-heda-gold transition-colors">
                <ImageIcon className="w-10 h-10 mx-auto text-heda-mute mb-2" />
                <p className="text-sm text-heda-mute mb-2">Click to select an image</p>
                <p className="text-xs text-heda-mute">JPEG, PNG, WEBP or GIF (max 5MB)</p>
                <input 
                  ref={imageInputRef}
                  type="file" 
                  accept="image/jpeg,image/png,image/webp,image/gif" 
                  onChange={handleImageUpload}
                  className="absolute inset-0 opacity-0 cursor-pointer"
                  data-testid="image-file-input"
                />
              </div>

              <div className="flex gap-2">
                <Button 
                  variant="outline" 
                  onClick={() => setShowImageDialog(false)} 
                  className="rounded-xl border-heda-line bg-white text-heda-ink shadow-none hover:bg-heda-cream/60 flex-1"
                  disabled={uploading}
                >
                  Cancel
                </Button>
                <Button 
                  onClick={() => imageInputRef.current?.click()} 
                  className="rounded-xl bg-heda-ink text-white shadow-none hover:bg-black flex-1"
                  disabled={uploading}
                  data-testid="upload-image-btn"
                >
                  {uploading ? 'Uploading...' : <><Upload className="w-4 h-4 mr-2" /> Upload</>}
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
